export const TEMPLATES = [
  {
    id: "floating",
    name: "Floating Chat Icon",
    description: "Floating icon with rotating messages and badge.",
    category: "Classic",
    features: {
      animation: true,
      rotatingMessages: true,
      avatar: false,
      notificationBadge: true,
    },
  },
  {
    id: "promo_card",
    name: "Promotional Card",
    description: "Offer card with discount banner and CTA.",
    category: "Marketing",
    features: {
      animation: true,
      rotatingMessages: false,
      avatar: false,
      notificationBadge: false,
    },
  },
  {
    id: "assistant_bubble",
    name: "Guest Relations Assistant",
    description: "Agent bubble with name, role and greeting.",
    category: "Conversational",
    features: {
      animation: true,
      rotatingMessages: true,
      avatar: true,
      notificationBadge: false,
    },
  },
  {
    id: "sticky_bar",
    name: "Sticky Engagement Bar",
    description: "Bottom bar that opens chatbot on click.",
    category: "Engagement",
    features: {
      animation: true,
      rotatingMessages: false,
      avatar: false,
      notificationBadge: false,
    },
  },
  {
    id: "concierge",
    name: "Premium Concierge",
    description: "Luxury card with avatar and services.",
    category: "Premium",
    features: {
      animation: true,
      rotatingMessages: false,
      avatar: true,
      notificationBadge: true,
    },
  },
];

export const ANIMATION_TYPES = [
  { id: "bounce", label: "Bounce" },
  { id: "pulse", label: "Pulse" },
  { id: "floating", label: "Floating" },
  { id: "slideIn", label: "Slide In" },
  { id: "fadeIn", label: "Fade In" },
  { id: "zoomIn", label: "Zoom In" },
  { id: "wave", label: "Wave" },
  { id: "glow", label: "Glow Effect" },
];

export const ANIMATION_FREQUENCIES = [
  { id: "continuous", label: "Continuous" },
  { id: "5s", label: "Every 5 seconds" },
  { id: "10s", label: "Every 10 seconds" },
  { id: "15s", label: "Every 15 seconds" },
  { id: "30s", label: "Every 30 seconds" },
  { id: "60s", label: "Every 60 seconds" },
];

// Animations that are one-shot (play once, not loopable)
export const ONE_SHOT_ANIMATIONS = ["slideIn", "fadeIn", "zoomIn"];

export const DESKTOP_POSITIONS = [
  { id: "bottom-right", label: "Right", icon: "bi-arrow-down-right" },
  { id: "bottom-left", label: "Left", icon: "bi-arrow-down-left" },
];

export const FONT_FAMILIES = [
  "Nunito",
  "Inter",
  "Roboto",
  "Open Sans",
  "Lato",
  "Poppins",
  "Playfair Display",
  "Montserrat",
  "Source Sans Pro",
  "Raleway",
];

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ar", label: "Arabic" },
  { code: "hi", label: "Hindi" },
  { code: "fr", label: "French" },
  { code: "de", label: "German" },
  { code: "es", label: "Spanish" },
];

export const AUTO_OPEN_DELAYS = [
  { value: 0, label: "Never" },
  { value: 5, label: "5 seconds" },
  { value: 10, label: "10 seconds" },
  { value: 20, label: "20 seconds" },
  { value: 30, label: "30 seconds" },
];

export const TRIGGER_TYPES = [
  { id: "scroll", label: "Scroll Percentage", icon: "bi-arrow-down" },
  { id: "exit_intent", label: "Exit Intent", icon: "bi-box-arrow-up-right" },
  { id: "returning_visitor", label: "Returning Visitor", icon: "bi-person-check" },
  { id: "page_specific", label: "Page Specific Trigger", icon: "bi-file-earmark" },
];

export const DEFAULT_WIDGET_CONFIG = {
  template: "floating",
  appearance: {
    primaryColor: "#9b4598",
    secondaryColor: "#e1bee7",
    backgroundColor: "#ffffff",
    textColor: "#000000",
    borderRadius: 12,
    widgetSize: 60,
    iconSize: 28,
    fontFamily: "Nunito",
    fontSize: 14,
    avatarImage: "",
    hotelLogo: "",
    customIcon: "",
  },
  position: {
    desktop: "bottom-right",
    mobile: "bottom-right",
    bottomSpacing: 20,
    leftSpacing: 20,
    rightSpacing: 20,
  },
  welcome: {
    title: "Welcome to our Hotel",
    subtitle: "Ask me about rooms, dining and offers.",
    ctaText: "Chat Now",
    typingMessages: [
      "Looking for rooms?",
      "Book direct & save!",
      "AI assistant at your service",
    ],
  },
  animation: {
    enabled: true,
    type: "pulse",
    frequency: "continuous",
  },
  proactive: {
    autoOpenDelay: 0,
    triggers: [],
    scrollPercentage: 50,
    customRules: [],
  },
  behavior: {
    autoOpen: false,
    autoMinimize: false,
    rememberState: true,
    openOnRevisit: false,
    showUnreadBadge: true,
    notificationCount: 0,
    soundNotification: false,
    typingIndicator: true,
  },
  deviceVisibility: {
    desktop: true,
    mobile: true,
    tablet: true,
  },
  branding: {
    agentName: "AI Concierge",
    agentAvatar: "",
    conciergeName: "",
    conciergeTheme: "default",
  },
  multiLanguage: {
    defaultLanguage: "en",
    enabledLanguages: ["en"],
    welcomeByLanguage: {},
    buttonsByLanguage: {},
  },
  chatTheme: {
    chatprimaryBg: "#9b4598",
    chatprimaryText: "#ffffff",
    submenuBg: "#ffffff",
    submenuText: "#000000",
    submenuHoverBg: "#e1bee7",
    botBg: "#ffffff",
    botText: "#000000",
    chatBgColor: "#f6f6f6",
    logoBgColor: "#ffffff",
  },
  templateContent: {
    floating: {
      messages: [
        "Looking for rooms?",
        "Book direct & save!",
        "AI assistant at your service",
      ],
      displayStyle: "stacked",
    },
    promo_card: {
      title: "Weekend Getaway Package",
      description: "Book a suite this weekend and save big",
      buttonText: "Grab This Deal",
    },
    assistant_bubble: {
      agentName: "Emma",
      role: "Guest Relations",
      greeting: "Ask me about rooms, dining and offers.",
      buttonText: "Chat Now",
    },
    sticky_bar: {
      message: "Need help planning your stay?",
      buttonText: "Chat Now",
    },
    concierge: {
      title: "Personal Concierge",
      subtitle: "At your service",
      greeting: "Good evening. How may I assist you today?",
      services: ["Room Service", "Spa", "Dining"],
      buttonText: "Request Concierge",
    },
  },
  presets: [],
};

export const PRESET_EXAMPLES = [
  {
    id: "luxury",
    name: "Luxury Hotel Theme",
    icon: "bi-gem",
    chatTheme: {
      chatprimaryBg: "#1a1a2e",
      chatprimaryText: "#ffffff",
      submenuBg: "#ffffff",
      submenuText: "#1a1a2e",
      submenuHoverBg: "#c9a961",
      botBg: "#ffffff",
      botText: "#1a1a2e",
      chatBgColor: "#f9f9f9",
      logoBgColor: "#ffffff",
    },
  },
  {
    id: "resort",
    name: "Resort Theme",
    icon: "bi-sun",
    chatTheme: {
      chatprimaryBg: "#00796b",
      chatprimaryText: "#ffffff",
      submenuBg: "#ffffff",
      submenuText: "#00796b",
      submenuHoverBg: "#b2dfdb",
      botBg: "#ffffff",
      botText: "#333333",
      chatBgColor: "#f5f5f5",
      logoBgColor: "#ffffff",
    },
  },
  {
    id: "budget",
    name: "Budget Hotel Theme",
    icon: "bi-wallet2",
    chatTheme: {
      chatprimaryBg: "#1565c0",
      chatprimaryText: "#ffffff",
      submenuBg: "#ffffff",
      submenuText: "#1565c0",
      submenuHoverBg: "#bbdefb",
      botBg: "#ffffff",
      botText: "#333333",
      chatBgColor: "#f5f5f5",
      logoBgColor: "#ffffff",
    },
  },
  {
    id: "business",
    name: "Business Hotel Theme",
    icon: "bi-briefcase",
    chatTheme: {
      chatprimaryBg: "#37474f",
      chatprimaryText: "#ffffff",
      submenuBg: "#ffffff",
      submenuText: "#37474f",
      submenuHoverBg: "#b0bec5",
      botBg: "#ffffff",
      botText: "#333333",
      chatBgColor: "#f5f5f5",
      logoBgColor: "#ffffff",
    },
  },
];

export const SECTION_IDS = {
  TEMPLATES: "templates",
  APPEARANCE: "appearance",
};

export const SECTIONS = [
  { id: SECTION_IDS.TEMPLATES, label: "Widget Design", icon: "bi-grid-3x3-gap" },
  { id: SECTION_IDS.APPEARANCE, label: "Colors & Theme", icon: "bi-palette2" },
];
